const _ = require('lodash');

const Place = require('./place');

const buildLabel = region => _.get(region, 'raw.display_name', _([region.locality, region.neighbourhood, region.city, region.county, region.state, region.country]).compact().join(', '));

class Region extends Place {
  /*:: static fromJson: (Object) => Region; */
  constructor(args
  /*: PlaceInitObject*/
  ) {
    super(args);
    this.label = buildLabel(this);
  }

}

Region.fromJson = json => new Region(Region.jsonToInitObj(json));

Region.fromJsonSimple = json => new Region(json);

module.exports = Region;